<template>
  <div class="account-status">
    <div class="status-inner">
      <img class="image" src="/assets/images/delete-warning.svg" width="112" height="112" alt=""/>
      <h2 class="title">{{ $t('accountStatus.blockedTitle') }}</h2>
      <p class="description">{{ $t('accountStatus.blockedDescription') }}</p>
      <base-link variant="primary-button" class="status-button" href="/racuni" @click.native="showLoader">{{ $t('accountStatus.blockedButton') }}</base-link>
      <base-button v-if="Object.keys($props.unsuspend).length" variant="secondary" class="status-button" @click="modalVisible = true">{{ $t('unsuspendMe.cta') }}</base-button>
    </div>
    <confirmation-modal v-if="Object.keys($props.unsuspend).length"
                        :visible="modalVisible"
                        confirm-type="empty"
                        :confirm-title="modalText.title"
                        :dynamic-data-description="modalText.message"
                        :confirm-text="$t('common.activate')"
                        :confirm-button="!submittedSuccessfully"
                        :cancel-text="modalText.cancel"
                        cancel-button
                        :loading="confirmationLoader"
                        @close="close"
                        @confirm="activate"/>
  </div>
</template>

<script>
import ConfirmationModal from '@/components/common/modal/confirmation-modal'
import errorMessageHandler from '@/mixins/errorMessageHandler'

export default {
  name: 'account-status-blocked',
  components: { ConfirmationModal },
  mixins: [errorMessageHandler],
  props: {
    resourcesData: {
      type: Object,
      default: () => ({})
    },
    unsuspend: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      modalVisible: false,
      confirmationLoader: false,
      submittedSuccessfully: false
    }
  },

  computed: {
    modalText () {
      return {
        title: this.submittedSuccessfully ? this.$t('toastMessages.successToastTitle') : this.$t('unsuspendMe.modal.title'),
        message: this.submittedSuccessfully ? this.$t('unsuspendMe.successMessage') : this.$t('unsuspendMe.modal.text', { amount: this.$props.unsuspend.formattedValue }),
        cancel: this.submittedSuccessfully ? this.$t('common.close') : this.$t('common.cancel')
      }
    }
  },

  methods: {
    showLoader () {
      this.$loader.show()
    },
    activate () {
      this.confirmationLoader = true
      const data = {
        subscriberIdentity: this.$props.resourcesData.subscriberIdentity
      }
      this.$apiRequest.post('user/services/unsuspend', data).then(() => {
        this.submittedSuccessfully = true
        this.$emit('refresh-data', this.$props.resourcesData.subscriberIdentity)
      }).catch(e => {
        this.handleErrorMessage(e.response.data)
      }).finally(() => {
        this.confirmationLoader = false
      })
    },
    close () {
      this.modalVisible = false
      this.submittedSuccessfully = false
    }
  }
}
</script>

<style scoped lang="scss" src="./account-status.scss"></style>
